<template>
  <ul class="chat-list">
    <li class="chat-item">
      <router-link to="/chatView">
        <div class="avatar">
          <img src="../assets/img-user-default.png" alt="" />
        </div>
        <div class="chat-info">
          <div class="top">
            <strong class="name">상큼아삭사과</strong>
            <ul>
              <li>망원동</li>
              <li>2주전</li>
            </ul>
          </div>
          <div class="bottom">
            <p>
              안녕하세요. 상품 팔렸나요? 구매하고싶어요. 완전 제가 찾던 상품 그
              자체거든요.
            </p>
          </div>
        </div>
      </router-link>
    </li>
  </ul>
</template>
